module.exports = __webpack_public_path__ + "static/media/Grupo 4876.1a358ef1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/Grupo 4876.svg
// module id = 359
// module chunks = 0